import React, { useRef, useState, useEffect } from "react";
import { Navbar, Button } from "flowbite-react";
import { HiArrowLeft } from "react-icons/hi2";
import ltaVehicleLog from "../../../img/lta-vehicle-log.svg";
import { FaCamera } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { handleLtaInspectionLog, handleLtaInspectionLogUpload } from "./handler" ;
import { MdCheckCircle } from "react-icons/md";
import { BsThreeDots } from "react-icons/bs";

const LtaVehicleInspectionLogComponent = (props) => {
    const ltaInspectionLogRef = useRef(null);

  const cssForImageCard = {
    success : {
      imageDiv: 'mt-2 mb-10 custom-card-success border rounded-md items-center shadow-none p-10',
    },
    standard : {
      imageDiv: 'mt-2 mb-10 custom-card border rounded-md items-center shadow-none p-10',
    }
  }

  const selectedProfileType = JSON.parse(sessionStorage.getItem("selectedProfileType"));

  const navigate = useNavigate();
  let [ltaInspectionLog, setLtaInspectionLog] = useState();
  let [userUploadedLog, setUserUploadedLog] = useState(false)
  let [logPicLoading, setLogPicLoading] = useState(false)
  let [validationOnSubmit, setValidationOnSubmit] = useState(false)
  let [showButton, setShowButton] = useState(false)
  let [validation, setValidation] = useState({
    show: false,
    message: "",
    class: "",
  });

  useEffect(() => {
    handleLtaInspectionLog(props.itemIndex, props.memberRequirement.requiredDocuments, setLtaInspectionLog, setUserUploadedLog, ltaVehicleLog)
  },[])

    return (
      <>
        <Navbar
          fluid={true}
          rounded={true}
          className="shadow mb-3"
          style={{ position: "fixed", width: "100%", top: "0" }}
        >
          <Navbar.Brand
            onClick={() => {
              props.setOpenUploadDocument({
                openDocument: false,
                documentType: "",
              });
            }}
          >
            <HiArrowLeft className="h-10 w-5 ml-2" />
          </Navbar.Brand>
        </Navbar>
        <div className='p-6  max-w-md m-auto' style={{paddingTop:'80px'}}>
          <h5 className="text-2xl mb-2 font-bold tracking-tight text-gray-900 dark:text-white">
          LTA Vehicle Log
          </h5>
          {
            validationOnSubmit && 
            <div className="error-msg">
              <span>Need to LTA Inspection Log before submitting for verification</span>
            </div>
          }
          { 
            validation.show && 
            <div className="error-msg">
              <span>{validation.message}</span>
            </div>
          }
          {
          userUploadedLog && 
          <div class="inline-flex items-center text-base font-semibold text-gray-900 dark:text-white" style={{paddingRight: '10px'}}>
            <MdCheckCircle style = {{ color: '#15BE44' }}/>
          </div>
          }
          <label className='font-bold tracking-tight text-gray-900'>Image</label>
          <div className={ userUploadedLog ?  cssForImageCard.success.imageDiv : cssForImageCard.standard.imageDiv }>
          {
            validation.show && (
              <div className={validation.class}>
                 <span>{validation.message}</span>
              </div>
            )
          }
              <img src={ltaInspectionLog}
                  className="w-auto m-auto"
                  alt="Ryde" 
              />
              <p className='text-xs text-gray-400 tracking-tight mt-2'><i>Your LTA vehicle log must show these 3 things:<br/>
                  1. License Plate Number <br/>
                  2. Vehicle Type is Z10/Z11<br/>
                  3. Valid expiry date<br/><br/><br/>
                  You may visit LTA ONE MOTORING website to retrieve your vehicle log<br/> 
                  </i></p>
              <Button  pill={true} className='mt-5 m-auto w-sm pr-4' onClick={(e)=>{
                e.preventDefault();
                ltaInspectionLogRef.current.click();
                }}>
                 {
                logPicLoading ? <BsThreeDots className="h-5 w-10" /> : <FaCamera className="h-5 w-10" />
              }
                  <label // for="file-upload"
                  className="relative cursor-pointer rounded-md font-medium">
                      <span>Upload</span>
                  </label> 
              </Button>
              <input 
                  id="file-upload" 
                  name="file-upload"
                  type="file"
                  ref={ltaInspectionLogRef}
                  style={{display: 'none', width:'0px'}}
                  // onChange={(event)=>{handleFileChange(event,"vehicleLog")}}
                  onChange={async (event) => {
                    await handleLtaInspectionLogUpload(event, setValidation, setLogPicLoading, setUserUploadedLog,
                      "vehicleLog", "ltaInspectionLog", selectedProfileType.profileId, setLtaInspectionLog, navigate, props.memberRequirement, props.setMemberRequirement,props.itemIndex);
                      setValidationOnSubmit(false)}}
              />
          </div>
  
          <Button className='bg-primary w-full mt-5' pill={true} disabled={false} 
              onClick={()=>{
                if(userUploadedLog ) {
                  props.setOpenUploadDocument({
                    openDocument: false,
                    documentType: "",
                  });
                } else {
                  setValidationOnSubmit(true)
                  window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
                }
              }}
          >
              Save
          </Button>
        </div>
      </>
    )
}

export default LtaVehicleInspectionLogComponent;